<template>
    <slot v-bind="{
        ...state,
        handleClick,
    }" />
</template>

<script setup>
import { onBeforeMount, reactive } from 'vue';

import favorites from '../services/favorites';

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
});

const state = reactive({
    artist: null,
    isFavorited: false,
    isProcessing: false,
});

const handleClick = () => {
    state.isProcessing = true;

    if (state.isFavorited) {
        favorites.unfavoriteArtist(state.artist);
        state.isFavorited = false;
    } else {
        favorites.favoriteArtist(state.artist);
        state.isFavorited = true;
    }

    state.isProcessing = false;
}

onBeforeMount(() => {
    if (!props.id) {
        return;
    }

    state.artist = {
        id: props.id,
    }

    state.isFavorited = favorites.isFavoriteArtist(state.artist);
});
</script>
